import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form"]
  static classes = ["hidden"]

  connect() {
    this.formSubmitEndHandler = this.formSubmitEnd.bind(this)
    this.transitionEndHandler = this.transitionEnd.bind(this)

    if (this.hasFormTarget) {
      this.formTarget.addEventListener("turbo:submit-end", this.formSubmitEndHandler)
    }
  }

  disconnect() {
    if (this.hasFormTarget) {
      this.formTarget.removeEventListener("turbo:submit-end", this.formSubmitEndHandler)
    }

    this.element.removeEventListener("transitionend", this.transitionEndHandler)
  }

  formSubmitEnd(event) {
    if (event.detail.success) {
      this.element.classList.add(this.hiddenClass)
      this.element.addEventListener("transitionend", this.transitionEndHandler, { once: true })
      this.announceCommentDeletion()
    }
  }

  announceCommentDeletion() {
    const message = this.element.dataset.commentDeletedMessage || "Comment deleted"
    window.dispatchEvent(new CustomEvent("aria-announcer:announce", {
      detail: { message, priority: "polite" }
    }))
  }

  transitionEnd() {
    this.element.remove()
  }
}
